import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useState,
} from "react";
import { useSelector } from "react-redux";

const AddressForm = forwardRef((props, ref) => {
	const state = useSelector((state) => state);
	const [inputs, setInputs] = useState({
		action: "update_Address",
		firstName:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].firstName
				: "",
		lastName:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].lastName
				: "",
		email:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].email
				: "",
		phone:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].phone
				: "",
		city:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].city
				: "",
		country:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].country
				: "",
		address1:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].address1
				: "",
		address2:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].address2
				: "",
		state_or_province:
			state.order.order.shippingInfo.length > 0
				? state.order.order.shippingInfo[0].state_or_province
				: "",
	});
	const [cond, setCond] = useState(false);

	const handleChange = (event) => {
		setInputs({ ...inputs, [event.target.name]: event.target.value });
	};
	useEffect(() => {
		console.log("AddressForm inputs=", inputs);
		if (
			inputs.address1 &&
			inputs.email &&
			inputs.phone &&
			inputs.city &&
			inputs.country &&
			inputs.firstName &&
			inputs.lastName &&
			inputs.state_or_province
		) {
			setCond(true);
		}
	}, [inputs, setInputs]);

	useImperativeHandle(ref, () => {
		return {
			addressInputs: inputs,
			addreesSaveCond: cond,
		};
	});

	console.log("AddressForm props.data=", props.data);
	return (
		<React.Fragment>
			<Typography variant="h6" gutterBottom>
				Shipping address
			</Typography>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="firstName"
						name="firstName"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].firstName
								: ""
						}
						label="First name"
						fullWidth
						autoComplete="given-name"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="lastName"
						name="lastName"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].lastName
								: ""
						}
						label="Last name"
						fullWidth
						autoComplete="family-name"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="email"
						name="email"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].email
								: ""
						}
						label="email"
						fullWidth
						autoComplete="email"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="phone"
						name="phone"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].phone
								: ""
						}
						label="phone"
						fullWidth
						autoComplete="phone"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						required
						id="address1"
						name="address1"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].address1
								: ""
						}
						label="Address line 1"
						fullWidth
						autoComplete="shipping address-line1"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12}>
					<TextField
						id="address2"
						name="address2"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].address2
								: ""
						}
						label="Address line 2"
						fullWidth
						autoComplete="shipping address-line2"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="city"
						name="city"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].city
								: ""
						}
						label="City"
						fullWidth
						autoComplete="shipping address-level2"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						id="state_or_province"
						name="state_or_province"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].state_or_province
								: ""
						}
						label="State/Province/Region"
						fullWidth
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="postalCode_or_zipCode"
						name="postalCode_or_zipCode"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].postalCode_or_zipCode
								: ""
						}
						label="Zip / Postal code"
						fullWidth
						autoComplete="shipping postal-code"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<TextField
						required
						id="country"
						name="country"
						defaultValue={
							state.order.order.shippingInfo.length > 0
								? state.order.order.shippingInfo[0].country
								: ""
						}
						label="Country"
						fullWidth
						autoComplete="shipping country"
						onChange={handleChange}
					/>
				</Grid>
				<Grid item xs={12}>
					<FormControlLabel
						control={
							<Checkbox
								color="secondary"
								name="saveAddress"
								defaultValue={
									state.order.order.shippingInfo.length > 0
										? state.order.order.shippingInfo[0].saveAddress
										: ""
								}
								value="yes"
								onChange={handleChange}
							/>
						}
						label="Use this address for payment details"
					/>
				</Grid>
			</Grid>
		</React.Fragment>
	);
});

export default AddressForm;
